module.exports = __webpack_public_path__ + "static/media/00-main02-pc_4x.dc17fcc6.png";